<div class="lecont" style="min-height: 100%;" [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting(), 'glassMode': appGlobals.getStoredGlassModeSetting()}">
  <div id="sidebarNav" class="sideBarNav">
    <div class="sideBarTopBtn"   matTooltip="Scroll to top" (click)="scrollToTop()">
      <i class="fal fa-fw fa-arrow-to-top"></i>
    </div>
    <div class="sideBarBtnSection">
      <a class="sideBarBtn nav-link" *ngFor="let table of lookupTables" data-bs-toggle="collapse" [href]="'#' + table.targetDivID" role="button" (click)="focusTable(table)">
        {{ table.name }}
      </a>
      <a class="sideBarBtn nav-link" *ngFor="let table of logTables" data-bs-toggle="collapse" [href]="'#' + table.targetDivID" role="button" (click)="focusTable(table)">
        {{ table.name }}
      </a>
    </div>
  </div>

  <div id="containingTable" class="containingTables">
    <div class="collapse" id="ctCollapse">
      <lib-new-table-editor #ctTable [modelName]="'Contact Type'"
        (messageEmitter)="sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
        (editModeEmitter)="updateActiveTables($event)"
        [userViewOptions]="lookupTables[0].tableViewOpts"
        (deleteConfirmEmitter)="sbCmpMsgSvc.dataDeleteConfirm($event)"
        [loadAllClientside]="false"
        [tooltipDelay]="1"
        [dataSvc]="contactTypeService"
        [columns]="lookupTables[0].columnDefs"
        [darkMode]="darkMode"
        [glassMode]="appGlobals.getStoredGlassModeSetting()"
        [tableEditable]="isAdmin">
        <h3>
          Contact Type Lookup Table
          <span type="button" class="close" [ngClass]="{'darkMode': darkMode}" style="font-size: 1.5em;" data-bs-toggle="collapse" data-bs-target="#ctCollapse" role="button" aria-label="close">
            <span aria-hidden="true">&times;</span>
          </span>
        </h3>
        <ng-template #rowTemplate let-rowData="rowData" let-columnDefinitions="lookupTables[0]?.columnDefs" let-editRow="editRow" let-tableViewOptions="userViewOptions">
          <span style="display: contents;" lib-table-color-row #colorRow [ngClass]="{'darkMode': darkMode}"
            [darkMode]="darkMode"
            [rowData]="rowData"
            [columnDefinitions]="lookupTables[0]?.columnDefs"
            [editRow]="editRow"
            [allowEdit]="isAdmin"
            [tableViewOptions]="tableViewOptions"
            (cancelEmitter)="ctTable.cancelChanges($event)"
            (selectedEmitter)="ctTable.changeEditMode(!editRow, rowData?.uid)"
            (deleteEmitter)="ctTable.deleteRecordPressed($event)"
            (saveEmitter)="ctTable.saveChanges($event)">
          </span>
        </ng-template>
      </lib-new-table-editor>
    </div>
    <div class="collapse" id="gmCollapse">
      <lib-new-table-editor #gmTable [modelName]="'Grid'"
        (messageEmitter)="sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
        (editModeEmitter)="updateActiveTables($event)"
        [userViewOptions]="lookupTables[1].tableViewOpts"
        (deleteConfirmEmitter)="sbCmpMsgSvc.dataDeleteConfirm($event)"
        [tooltipDelay]="1"
        [loadAllClientside]="false"
        [dataSvc]="gridModelService"
        [columns]="lookupTables[1].columnDefs"
        [darkMode]="darkMode"
        [glassMode]="appGlobals.getStoredGlassModeSetting()"
        [tableEditable]="isAdmin">
        <h3>
          Grid Lookup Table
          <span type="button" class="close" [ngClass]="{'darkMode': darkMode}" style="font-size: 1.5em;" data-bs-toggle="collapse" data-bs-target="#gmCollapse" role="button" aria-label="close">
            <span aria-hidden="true">&times;</span>
          </span>
        </h3>
        <ng-template #rowTemplate let-rowData="rowData" let-columnDefinitions="lookupTables[2].columnDefs" let-editRow="editRow" let-compactMode="compactMode">
          <span style="display: contents;" lib-table-row
            [rowData]="rowData"
            [columnDefinitions]="lookupTables[1].columnDefs"
            [editRow]="editRow"
            [allowEdit]="isAdmin"
            [compactMode]="compactMode"
            [darkMode]="darkMode"
            (cancelEmitter)="gmTable.cancelChanges($event)"
            (selectedEmitter)="gmTable.changeEditMode(!editRow, rowData.uid)"
            (deleteEmitter)="gmTable.deleteRecordPressed($event)"
            (saveEmitter)="gmTable.saveChanges($event)">
          </span>
        </ng-template>
      </lib-new-table-editor>
    </div>
    <div class="collapse" id="jcatCollapse">
      <lib-new-table-editor #jcatTable
        [modelName]="'Job Categories'"
        (messageEmitter)="sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
        (editModeEmitter)="updateActiveTables($event)"
        [userViewOptions]="lookupTables[2].tableViewOpts"
        (deleteConfirmEmitter)="sbCmpMsgSvc.dataDeleteConfirm($event)"
        [loadAllClientside]="false"
        [tooltipDelay]="1"
        [dataSvc]="jobCategoryService"
        [columns]="lookupTables[2].columnDefs"
        [darkMode]="darkMode"
        [glassMode]="appGlobals.getStoredGlassModeSetting()"
        [tableEditable]="isAdmin">
        <h3>
          Job Category Lookup Table
          <span type="button" class="close" [ngClass]="{'darkMode': darkMode}" style="font-size: 1.5em;" data-bs-toggle="collapse" data-bs-target="#jcatCollapse" role="button" aria-label="close">
            <span aria-hidden="true">&times;</span>
          </span>
        </h3>
        <ng-template #rowTemplate let-rowData="rowData" let-columnDefinitions="lookupTables[2].columnDefs" let-editRow="editRow" let-compactMode="compactMode">
          <span style="display: contents;" lib-table-row
            [rowData]="rowData"
            [columnDefinitions]="lookupTables[2].columnDefs"
            [editRow]="editRow"
            [allowEdit]="isAdmin"
            [compactMode]="compactMode"
            [darkMode]="darkMode"
            (cancelEmitter)="jcatTable.cancelChanges($event)"
            (selectedEmitter)="jcatTable.changeEditMode(!editRow, rowData.uid)"
            (deleteEmitter)="jcatTable.deleteRecordPressed($event)"
            (saveEmitter)="jcatTable.saveChanges($event)">
          </span>
        </ng-template>
      </lib-new-table-editor>
    </div>
    <div class="collapse" id="jcCollapse">
      <lib-new-table-editor #jcTable
        [modelName]="'Job Codes'"
        (messageEmitter)="sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
        (editModeEmitter)="updateActiveTables($event)"
        [userViewOptions]="lookupTables[3].tableViewOpts"
        (deleteConfirmEmitter)="sbCmpMsgSvc.dataDeleteConfirm($event)"
        [usePagination]="true"
        [loadAllClientside] = "false"
        [tooltipDelay]="1"
        [dataSvc]="jobCodeService"
        [columns]="lookupTables[3].columnDefs"
        [darkMode]="darkMode"
        [glassMode]="appGlobals.getStoredGlassModeSetting()"
        [tableEditable]="isAdmin">
        <h3>
          Job Code Lookup Table
          <span type="button" class="close" [ngClass]="{'darkMode': darkMode}" style="font-size: 1.5em;" data-bs-toggle="collapse" data-bs-target="#jcCollapse" role="button" aria-label="close">
            <span aria-hidden="true">&times;</span>
          </span>
        </h3>
        <ng-template #rowTemplate let-rowData="rowData" let-columnDefinitions="lookupTables[3].columnDefs" let-editRow="editRow" let-compactMode="compactMode">
          <span style="display: contents;" lib-table-row
            [rowData]="rowData"
            [columnDefinitions]="lookupTables[3].columnDefs"
            [editRow]="editRow"
            [allowEdit]="isAdmin"
            [compactMode]="compactMode"
            [darkMode]="darkMode"
            (cancelEmitter)="jcTable.cancelChanges($event)"
            (selectedEmitter)="jcTable.changeEditMode(!editRow, rowData.uid)"
            (deleteEmitter)="jcTable.deleteRecordPressed($event)"
            (saveEmitter)="jcTable.saveChanges($event)">
          </span>
        </ng-template>
      </lib-new-table-editor>
    </div>
    <div class="collapse wide" style="width: 95%;" id="msCollapse">
      <lib-new-table-editor #msTable [modelName]="'Materials Services'"
        (messageEmitter)="sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
        (editModeEmitter)="updateActiveTables($event)"
        [userViewOptions]="lookupTables[4].tableViewOpts"
        (deleteConfirmEmitter)="sbCmpMsgSvc.dataDeleteConfirm($event)"
        [loadAllClientside]="false"
        [tooltipDelay]="1"
        [dataSvc]="materialsServices"
        [columns]="lookupTables[4].columnDefs"
        [darkMode]="darkMode"
        [glassMode]="appGlobals.getStoredGlassModeSetting()"
        [tableEditable]="isAdmin">
        <h3>
          Materials & Services Lookup Table
          <span type="button" class="close" [ngClass]="{'darkMode': darkMode}" style="font-size: 1.5em;" data-bs-toggle="collapse" data-bs-target="#msCollapse" role="button" aria-label="close">
            <span aria-hidden="true">&times;</span>
          </span>
        </h3>
        <ng-template #rowTemplate let-rowData="rowData" let-columnDefinitions="lookupTables[4].columnDefs" let-editRow="editRow" let-compactMode="compactMode">
          <span style="display: contents;" lib-table-row
          [rowData]="rowData"
          [columnDefinitions]="lookupTables[4].columnDefs"
          [editRow]="editRow"
          [allowEdit]="isAdmin"
          [compactMode]="compactMode"
          [darkMode]="darkMode"
          (cancelEmitter)="msTable.cancelChanges($event)"
          (selectedEmitter)="msTable.changeEditMode(!editRow, rowData.uid)"
          (deleteEmitter)="msTable.deleteRecordPressed($event)"
          (saveEmitter)="msTable.saveChanges($event)">
          </span>
        </ng-template>
        <ng-template #subRowTemplate let-rowData="rowData" let-columnDefinitions="lookupTables[4].columnDefs" let-editRow="editRow" let-compactMode="compactMode">
          <td style="border: 0; padding: 0; margin: 0;">
            <div style="margin-left: 30px; padding-bottom: 5px; margin-bottom: 20px;">
              <span class="subrowHeader">Tax Code</span>
              <hr>
              <span *ngIf="!editRow && (!rowData.matSvcTaxes || rowData.matSvcTaxes?.length === 0)">< No taxes ></span>
              <div class="divWidth">
                <input class="btn btn-outline-secondary ng-star-inserted" style="margin-bottom: 10px;" type="button"
                    *ngIf="editRow" value="+ New" (click)="addMatSvcTax(rowData);">
                <div *ngFor="let tax of rowData.matSvcTaxes, let i = index" class="dropdownBar">
                  <table style="width: auto;">
                    <tr>
                      <td style="border:0; outline:0">
                        <div *ngIf="tax.uid > 0" class="labelDropDownWidth" style="font-weight: bold;">
                          {{ (tax ?  (tax.tax ? tax.tax.code : "") : "") }}
                        </div>
                        <mat-form-field *ngIf="tax.uid === 0" appearance="fill">
                          <!--<mat-label>Taxes list</mat-label>-->
                          <mat-select [typeaheadDebounceInterval]="dropdownTypeDebounceTime" [(ngModel)]="tax.taxUID" placeholder="Select Tax">
                            <mat-option class="multiline-mat-option" *ngFor="let taxItem of taxList" [value]="taxItem.uid">
                              <div style="font-size: 14px;">{{taxItem.code}}</div>
                              <div style="font-size: 13px; color: darkslategray;">{{ taxItem.description}}</div>
                            </mat-option>
                          </mat-select>
                          </mat-form-field>
                      </td>
                      <td style="border:0; outline:0">
                          <button *ngIf="editRow" (click)="cancelTax(rowData.matSvcTaxes,i)" class="btn btn-outline-warning ng-star-inserted"> <i class="fal fa-times fa-fw"></i></button>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </td>
          <td style="border: 0;">
            <span class="subrowHeader">Tax Description</span>
            <hr style="position: relative; bottom: 1px; right: 11px;">
            <div *ngIf="!editRow" style="margin-top: 0px;">
              <div *ngFor="let tax of rowData.matSvcTaxes, let i = index">
                <table style="width: auto; border:0; outline:0">
                  <tr>
                    <td style="border:0; outline:0; white-space: nowrap;">
                      {{ (tax ?  (tax.tax ? tax.tax.description : "") : "") }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </td>
          <td style="border: 0;" [style.min-width]="editRow ? '250px' : 'auto'"></td>
          <td style="border: 0;"></td>
          <td style="border: 0;"></td>
          <td style="border: 0;"></td>
          <td style="border: 0;"></td>
          <td style="border: 0;"></td>
          <td style="border: 0;"></td>
          <td style="border: 0;"></td>
          <td style="border: 0;"></td>
        </ng-template>
      </lib-new-table-editor>
    </div>
    <div class="collapse wide" style="width: 95%;" id="mscCollapse">
      <lib-new-table-editor #mscTable [modelName]="'Material Subcategories'"
        (messageEmitter)="sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
        (editModeEmitter)="updateActiveTables($event)"
        [userViewOptions]="lookupTables[5].tableViewOpts"
        (deleteConfirmEmitter)="sbCmpMsgSvc.dataDeleteConfirm($event)"
        [loadAllClientside]="false"
        [dataSvc]="matSubCategorySvc"
        [tooltipDelay]="1"
        [columns]="lookupTables[5].columnDefs"
        [darkMode]="darkMode"
        [glassMode]="appGlobals.getStoredGlassModeSetting()"
        [tableEditable]="isAdmin">
        <h3>
          Material Subcategory Lookup Table
          <span type="button" class="close" [ngClass]="{'darkMode': darkMode}" style="font-size: 1.5em;" data-bs-toggle="collapse" data-bs-target="#mscCollapse" role="button" aria-label="close">
            <span aria-hidden="true">&times;</span>
          </span>
        </h3>
        <ng-template #rowTemplate let-rowData="rowData" let-columnDefinitions="lookupTables[5].columnDefs" let-editRow="editRow" let-compactMode="compactMode">
          <span style="display: contents;" lib-table-row
            [rowData]="rowData"
            [columnDefinitions]="lookupTables[5].columnDefs"
            [editRow]="editRow"
            [allowEdit]="isAdmin"
            [compactMode]="compactMode"
            [darkMode]="darkMode"
            (cancelEmitter)="mscTable.cancelChanges($event)"
            (selectedEmitter)="mscTable.changeEditMode(!editRow, rowData.uid)"
            (deleteEmitter)="mscTable.deleteRecordPressed($event)"
            (saveEmitter)="mscTable.saveChanges($event)">
          </span>
        </ng-template>
      </lib-new-table-editor>
    </div>
    <div class="collapse wide" style="width: 95%;" id="txCollapse">
      <lib-new-table-editor #txTable [modelName]="'Taxes'"
        (messageEmitter)="sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
        (editModeEmitter)="updateActiveTables($event)"
        [userViewOptions]="lookupTables[6].tableViewOpts"
        (deleteConfirmEmitter)="sbCmpMsgSvc.dataDeleteConfirm($event)"
        [loadAllClientside]="false"
        [dataSvc]="taxModelService"
        [tooltipDelay]="1"
        [columns]="lookupTables[6].columnDefs"
        [darkMode]="darkMode"
        [glassMode]="appGlobals.getStoredGlassModeSetting()"
        [tableEditable]="isAdmin">
        <h3>
          Tax Lookup Table
          <span type="button" class="close" [ngClass]="{'darkMode': darkMode}" style="font-size: 1.5em;" data-bs-toggle="collapse" data-bs-target="#txCollapse" role="button" aria-label="close">
            <span aria-hidden="true">&times;</span>
          </span>
        </h3>
        <ng-template #rowTemplate let-rowData="rowData" let-columnDefinitions="lookupTables[6].columnDefs" let-editRow="editRow" let-compactMode="compactMode">
          <span style="display: contents;" lib-table-row
            [rowData]="rowData"
            [columnDefinitions]="lookupTables[6].columnDefs"
            [editRow]="editRow"
            [allowEdit]="isAdmin"
            [compactMode]="compactMode"
            [darkMode]="darkMode"
            (cancelEmitter)="txTable.cancelChanges($event)"
            (selectedEmitter)="txTable.changeEditMode(!editRow, rowData.uid)"
            (deleteEmitter)="txTable.deleteRecordPressed($event)"
            (saveEmitter)="txTable.saveChanges($event)">
          </span>
        </ng-template>
      </lib-new-table-editor>
    </div>
    <div class="collapse wide" style="width: 95%;" id="trmCollapse">
      <lib-new-table-editor #trmTable [modelName]="'Terms'"
        (messageEmitter)="sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
        (editModeEmitter)="updateActiveTables($event)"
        [userViewOptions]="lookupTables[7].tableViewOpts"
        (deleteConfirmEmitter)="sbCmpMsgSvc.dataDeleteConfirm($event)"
        [loadAllClientside]="false"
        [dataSvc]="termModelSvc"
        [tooltipDelay]="1"
        [columns]="lookupTables[7].columnDefs"
        [darkMode]="darkMode"
        [tableEditable]="isAdmin">
        <h3>
          Terms Lookup Table
          <span type="button" class="close" [ngClass]="{'darkMode': darkMode}" style="font-size: 1.5em;" data-bs-toggle="collapse" data-bs-target="#trmCollapse" role="button" aria-label="close">
            <span aria-hidden="true">&times;</span>
          </span>
        </h3>
        <ng-template #rowTemplate let-rowData="rowData" let-columnDefinitions="lookupTables[7].columnDefs" let-editRow="editRow" let-compactMode="compactMode">
          <span style="display: contents;" lib-table-row
            [rowData]="rowData"
            [columnDefinitions]="lookupTables[7].columnDefs"
            [editRow]="editRow"
            [allowEdit]="isAdmin"
            [compactMode]="compactMode"
            [darkMode]="darkMode"
            (cancelEmitter)="trmTable.cancelChanges($event)"
            (selectedEmitter)="trmTable.changeEditMode(!editRow, rowData.uid)"
            (deleteEmitter)="trmTable.deleteRecordPressed($event)"
            (saveEmitter)="trmTable.saveChanges($event)">
          </span>
        </ng-template>
      </lib-new-table-editor>
    </div>
    <div class="collapse" id="uomCollapse">
      <lib-new-table-editor #uomTable [modelName]="'Unit of Measure'"
        (messageEmitter)="sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
        (editModeEmitter)="updateActiveTables($event)"
        [userViewOptions]="lookupTables[8].tableViewOpts"
        (deleteConfirmEmitter)="sbCmpMsgSvc.dataDeleteConfirm($event)"
        [loadAllClientside]="false"
        [tooltipDelay]="1"
        [dataSvc]="uomSvc"
        [columns]="lookupTables[8].columnDefs"
        [darkMode]="darkMode"
        [glassMode]="appGlobals.getStoredGlassModeSetting()"
        [tableEditable]="isAdmin">
        <h3>
          Unit of Measure Lookup Table
          <span type="button" class="close" [ngClass]="{'darkMode': darkMode}" style="font-size: 1.5em;" data-bs-toggle="collapse" data-bs-target="#uomCollapse" role="button" aria-label="close">
            <span aria-hidden="true">&times;</span>
          </span>
        </h3>
        <ng-template #rowTemplate let-rowData="rowData" let-columnDefinitions="lookupTables[8].columnDefs" let-editRow="editRow" let-compactMode="compactMode">
          <span style="display: contents;" lib-table-row
            [rowData]="rowData"
            [columnDefinitions]="lookupTables[8].columnDefs"
            [editRow]="editRow"
            [allowEdit]="isAdmin"
            [compactMode]="compactMode"
            [darkMode]="darkMode"
            (cancelEmitter)="uomTable.cancelChanges($event)"
            (selectedEmitter)="uomTable.changeEditMode(!editRow, rowData.uid)"
            (deleteEmitter)="uomTable.deleteRecordPressed($event)"
            (saveEmitter)="uomTable.saveChanges($event)">
          </span>
        </ng-template>
      </lib-new-table-editor>
    </div>
    <div class="collapse" id ="vehicleTypeCollapse">
      <lib-new-table-editor #vehicleTypeTable [modelName]="'Vehicle Type'"
        (messageEmitter)="sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
        (editModeEmitter)="updateActiveTables($event)"
        [userViewOptions]="lookupTables[9].tableViewOpts"
        (deleteConfirmEmitter)="sbCmpMsgSvc.dataDeleteConfirm($event)"
        [loadAllClientside]="false"
        [tooltipDelay]="1"
        [dataSvc]="vehicleTypeSvc"
        [columns]="lookupTables[9].columnDefs"
        [darkMode]="darkMode"
        [glassMode]="appGlobals.getStoredGlassModeSetting()"
        [tableEditable]="isAdmin">
        <h3>
          Vehicle Type Lookup Table
          <span type="button" class="close" [ngClass]="{'darkMode': darkMode}" style="font-size: 1.5em;" data-bs-toggle="collapse" data-bs-target="#vehicleTypeCollapse" role="button" aria-label="close">
            <span aria-hidden="true">&times;</span>
          </span>
        </h3>
        <ng-template #rowTemplate let-rowData="rowData" let-ColumnDefinitions="lookupTables[9].columnDefs" let-editRow="editRow" let-compactMode="compactMode">
          <span style="display: contents;" lib-table-row
            [rowData]="rowData"
            [columnDefinitions]="lookupTables[9].columnDefs"
            [editRow]="editRow"
            [allowEdit]="isAdmin"
            [compactMode]="compactMode"
            [darkMode]="darkMode"
            (cancelEmitter)="vehicleTypeTable.cancelChanges($event)"
            (selectedEmitter)="vehicleTypeTable.changeEditMode(!editRow, rowData.uid)"
            (deleteEmitter)="vehicleTypeTable.deleteRecordPressed($event)"
            (saveEmitter)="vehicleTypeTable.saveChanges($event)">
          </span>
        </ng-template>
      </lib-new-table-editor>
    </div>
    <div class="collapse" id="batchLogCollapse">
      <lib-new-table-editor #batchLogTable [modelName]="'Batch'"
        (messageEmitter)="sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
        (editModeEmitter)="updateActiveTables($event)"
        [userViewOptions]="logTables[0].tableViewOpts"
        (deleteConfirmEmitter)="sbCmpMsgSvc.dataDeleteConfirm($event)"
        [loadAllClientside]="false"
        [tooltipDelay]="1"
        [dataSvc]="batchSvc"
        [columns]="logTables[0].columnDefs"
        [darkMode]="darkMode"
        [glassMode]="appGlobals.getStoredGlassModeSetting()"
        [tableEditable]="false">
        <h3>
          Invoice Batch Logs
          <span type="button" class="close" [ngClass]="{'darkMode': darkMode}" style="font-size: 1.5em;" data-bs-toggle="collapse" data-bs-target="#batchLogCollapse" role="button" aria-label="close">
            <span aria-hidden="true">&times;</span>
          </span>
        </h3>
        <ng-template #rowTemplate let-rowData="rowData" let-ColumnDefinitions="logTables[0].columnDefs" let-editRow="editRow" let-compactMode="compactMode">
          <span style="display: contents;" lib-table-row
            [rowData]="rowData"
            [columnDefinitions]="logTables[0].columnDefs"
            [editRow]="editRow"
            [allowEdit]="false"
            [compactMode]="compactMode"
            [darkMode]="darkMode"
            (cancelEmitter)="vehicleTypeTable.cancelChanges($event)"
            (selectedEmitter)="vehicleTypeTable.changeEditMode(!editRow, rowData.uid)"
            (deleteEmitter)="vehicleTypeTable.deleteRecordPressed($event)"
            (saveEmitter)="vehicleTypeTable.saveChanges($event)">
          </span>
        </ng-template>
      </lib-new-table-editor>
    </div>
  </div>
</div>
